import Svg, { SvgProps, Path } from 'react-native-svg';

const TimerIcon = (props: SvgProps) => (
  <Svg viewBox="0 0 30 30" width={30} height={30} fill="#FFFFFF" {...props}>
    <Path d="M15 3a1 1 0 1 0 0 2 9.985 9.985 0 0 1 9.951 9.002 1 1 0 0 0 0 1.998 9.986 9.986 0 0 1-8.953 8.951A1 1 0 0 0 15 24a1 1 0 0 0-.998.951 9.986 9.986 0 0 1-8.953-8.953 1 1 0 0 0 .006-1.996 9.97 9.97 0 0 1 4.484-7.367L10.602 8 12 3.396l-4.846.176 1.147 1.471A11.996 11.996 0 0 0 3 15c0 6.615 5.385 12 12 12s12-5.385 12-12S21.615 3 15 3zm-.016 4.986A1 1 0 0 0 14 9v5.5l-3.6 2.7a1 1 0 1 0 1.2 1.6l4-3a1 1 0 0 0 .4-.8V9a1 1 0 0 0-1.016-1.014z" />
  </Svg>
);

export default TimerIcon;
